(() => {
  const SELECTOR = '[data-unsere-bestsellers]';

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    if (!window.Splide) return;

    const el = root.querySelector('.unsere-bestsellers__splide');
    if (!el) return;

    const count = el.querySelectorAll('.unsere-bestsellers__slide').length;
    if (!count) return;

    root.dataset.ready = 'true';

    root._splide = new window.Splide(el, {
      type: count > 3 ? 'loop' : 'slide',
      perPage: Math.min(3, count),
      gap: '20px',
      padding: 0,
      speed: 500,
      drag: count > 3,
      snap: true,
      arrows: false,
      pagination: count > 3,
      breakpoints: {
        989: {
          type: count > 1 ? 'loop' : 'slide',
          perPage: 1,
          gap: '10px',
          padding: { right: '30px' },
          drag: count > 1,
          pagination: count > 1
        }
      }
    }).mount();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SELECTOR).forEach((root) => {
      if (root._splide) {
        root._splide.destroy(true);
        delete root._splide;
      }
      delete root.dataset.ready;
    });
  });
})();
